import React from 'react';
import { useAuth } from '../../context/AuthContext';
import Header from '../../components/common/Header';
import Sidebar from '../../components/common/Sidebar';
import { User, Building2, Calendar } from 'lucide-react';
import './Profile.css';

const Profile = () => {
  const { user, employee } = useAuth();

  return (
    <div className="page-layout-root">
      <Header />
      <div className="page-body-wrapper">
        <Sidebar />
        <main className="page-main-content" style={{ maxWidth: '800px' }}>
          
          <div className="profile-header-box">
            <h1 className="profile-title">Employee Profile</h1>
            <p className="profile-subtitle">Account credentials and department assignment details.</p>
          </div>

          <div style={{ maxWidth: '480px', margin: '0 auto' }}>
            
            {/* Profile Card */}
            <div className="card profile-user-card">
              <div className="profile-avatar-circle">
                {user?.username?.substring(0, 2).toUpperCase()}
              </div>

              <h2 className="profile-name">
                {user?.first_name ? `${user.first_name} ${user.last_name || ''}` : user?.username}
              </h2>
              <span className="badge badge-primary" style={{ marginTop: '6px' }}>{user?.role}</span>

              <div className="profile-details-list">
                <div className="profile-detail-item">
                  <div className="profile-detail-icon-box user-icon">
                    <User size={18} />
                  </div>
                  <div className="profile-detail-info">
                    <div className="profile-detail-label">Office ID</div>
                    <div className="profile-detail-val">{employee?.office_id || 'N/A'}</div>
                  </div>
                </div>

                <div className="profile-detail-item">
                  <div className="profile-detail-icon-box dept-icon">
                    <Building2 size={18} />
                  </div>
                  <div className="profile-detail-info">
                    <div className="profile-detail-label">Department</div>
                    <div className="profile-detail-val">{employee?.department_detail?.name || 'Unassigned'}</div>
                  </div>
                </div>

                <div className="profile-detail-item">
                  <div className="profile-detail-icon-box date-icon">
                    <Calendar size={18} />
                  </div>
                  <div className="profile-detail-info">
                    <div className="profile-detail-label">Joining Date</div>
                    <div className="profile-detail-val">{employee?.joining_date || 'N/A'}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </main>
      </div>
    </div>
  );
};

export default Profile;
